import { VhvAction, VhvActions } from '../vhvActions';
import { VersicherungssummenResponseReceived } from '../action-types/versicherungssummenResponseReceived';

export function unterversicherungsVerzichtReducer(
  sectionState = false,
  action: VhvAction<VersicherungssummenResponseReceived>,
): boolean {
  if (action.type === VhvActions.VERSICHERUNGSSUMMEN_RESPONSE_RECEIVED) {
    return action.payload.unterversicherungsverzicht;
  }
  return sectionState;
}
